import api from "../axios";

interface CompleteTripPayload {
    cabid: string;
    bookingid: string | number;
    completedby: string;
    fare: number;
    mins: number;
    distance: number;
    piclat: number;
    piclon: number;
    present_location: string;
    feedback?: string;
    iscredit: boolean;
}

export const completeTripApi = (data: CompleteTripPayload) => {
    return api.post("/booking/completetrip", data);
};

export const getCompleteBookingByDateApi = (branchid: string, fromdate: string, todate: string) => {
    return api.get("/booking/getcompletebookingbydate", {
        params: { branchid, fromdate, todate },
    });
};